import { ServiceModel } from '../service-catalog/model';

export class TopServiceModel {
  public id: number;
  public rank: number = 0;
  public count: number;
  public serviceId: number;
  public service: ServiceModel;
}
